<template>
  <article class="trainers">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
             Videos
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="$router.push({name: 'news_new_video'})"
              >
                Crear nuevo video
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="findNews()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <section class="trainers__container">
          <section
            class="data_card_special"
            v-for="ne in news"
            :key="ne.id">
            <iframe
                v-if="ne.attributes.news_type == 'Video' || ne.attributes.url_type == 'video'"
                class="data_card_special__image"
                :src="'https://www.youtube.com/embed/' + ne.attributes.url.replace('https://youtu.be/','')+'?rel=0'"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                style="padding-top: 0; height: 200px; max-height: 200px;"
              ></iframe>
            <div
              v-else
              class="data_card_special__image"
              :style="{backgroundImage: 'url('+ getImageServer() + ne.attributes.url +')'}"></div>
            <div class="data_card_special__buttons">
              <div class="data_card_special__buttons--container">
                <div
                  class="data_card_special__buttons--edit"
                  @click="$router.push({name: 'edit_news_video', params: {news_id: ne.id}})">
                  <v-icon>create</v-icon>
                </div>
              </div>
            </div>
            <div class="data_card_special__info">
              <p class="data_card_special__info--title">
                {{ne.attributes.name}}
              </p>
              <div class="data_card_special__info--container">
                <span class="data_card_special__info--label">Fecha de publicación</span>
                <p class="data_card_special__info--text_date full_text">
                  {{ shortDate(ne.attributes.created_at) }}
                </p>
              </div>
              <!-- <div class="data_card_special__info--container">
                <span class="data_card_special__info--label">Descripción</span>
                <p class="data_card_special__info--text full_text">
                  {{ne.attributes.description}}
                </p>
              </div> -->
            </div>
          </section>
        </section>
      </div>
    </div>


  </article>
</template>

<script>
export default {
  props: ['type'],
  data(){
    return{
      news:[],
    }
  },
  methods:{
    shortDate(date){
      let new_date =  date.substring(0,date.indexOf('T'))
      return new_date
    },
    findNews(){
      try {
        this.$http.get('app/articles/'+this.type+'/show_by_state',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params: {
            company: this.getCompany().id
          }
        })
        .then(function(response){
          this.news = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findNewsByType(){
      try {
        this.$http.get('app/articles/'+this.type+'/show_by_news_type',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params: {
            company: this.getCompany().id
          }
        })
        .then(function(response){
          this.news = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findNewsTypeOrState(){
      if (this.type === 'all' || this.type === 'public' || this.type === 'hidden'){
        this.findNews()
      }
      if (this.type === 'Normal' || this.type === 'Video' || this.type === 'Titular') {
        this.findNewsByType()
      }
    }

  },
  mounted(){
    this.findNewsTypeOrState();
  },
  watch: {
    $route(to, from) {
      this.findNewsTypeOrState();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/news/video/Index.vue